<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57.5 32H32V14.5a1.5 1.5 0 00-1.5-1.5h-24A1.5 1.5 0 005 14.5v43A1.5 1.5 0 006.5 59h51a1.5 1.5 0 001.5-1.5v-24a1.5 1.5 0 00-1.5-1.5zM29 16v30H8V16zM8 49h21v7H8zm48 7H32V35h24z"/><path d="M21.5 51h-5a1.5 1.5 0 000 3h5a1.5 1.5 0 000-3zM33 7a16.51 16.51 0 0116.43 16l-2.72-2.73a1 1 0 00-1.42 0 1 1 0 000 1.41l4.5 4.51a1 1 0 00.7.29 1 1 0 00.71-.29l4.51-4.49a1 1 0 00-1.42-1.42l-2.86 2.85A18.51 18.51 0 0033 5a1 1 0 000 2z"/></svg>